import { Box, Button, Card, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Background from "../../assets/background.png";

interface INotFoundProps { }

const NotFound: FC<INotFoundProps> = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return <Box sx={
        {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            backgroundRepeat: "none",
            backgroundSize: "cover",
            backgroundImage: `url(${Background})`,
            backgroundPosition: "center"
        }
    }>
        <Box sx={
            {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
            }
        }>
            <Card sx={{
                width: 380,
                p: 2,
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center"
            }}>
                <Typography variant="h3" sx={{ mb: 1 }}>
                    404
                </Typography>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    {t("notFound")}
                </Typography>
                <Button variant="contained" onClick={() => navigate(-1)}>
                    {t("navigateBack")}
                </Button>
            </Card>
        </Box>
    </Box>
}

export default NotFound;